import React from 'react';

import FileSizeErrorModal from '../../../../commonComponents/Modals/FileSizeErrorModal/FileSizeErrorModal';
import Spinner from '../../../../commonComponents/Spinner/Spinner';

export default class UploadInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      waitingPrivateUrl: false,
      showFileSizeModal: false,
      fileSizeError: null,
    };
  }

  componentDidMount() {
    this.props.updateQuestionPdfProcessing(false);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.isPrivatePDF &&
      this.state.waitingPrivateUrl &&
      prevProps.urlPdfPrivate !== this.props.urlPdfPrivate
    ) {
      window.open(this.props.urlPdfPrivate, '_blank');
      this.setState({ waitingPrivateUrl: false });
    }
  }

  handleFileSizeError = (errorData) => {
    this.setState({
      showFileSizeModal: true,
      fileSizeError: errorData,
    });
  };

  closeFileSizeModal = () => {
    this.setState({
      showFileSizeModal: false,
      fileSizeError: null,
    });
  };

  onClickDeletePDF = (chapter, flag, reference) => {
    const { isWaiting, deletePdfChapter } = this.props;

    if (!isWaiting) {
      const newRef = {
        ...reference,
        pdfUrl: reference?.actAsParent ? reference.imageUrl : chapter.imageUrl,
      };
      deletePdfChapter(chapter, flag, newRef);
    }
  };

  getPrivateUrl = () => {
    this.setState({ waitingPrivateUrl: true });
    if (this.props.imageUrl)
      this.props.getPrivateUrl({ url: this.props.imageUrl });
    else this.props.getPrivateUrl({ url: this.props.chapter?.pdfUrl });
  };

  renderPdf(
    chapter,
    updateQuestionPdfProcessing,
    questionPdfProcessing,
    updateChapter,
    accept = 'application/pdf',
    className = '',
    reference,
  ) {
    if (questionPdfProcessing) {
      return (
        <div className="pdf-upload">
          <Spinner />
        </div>
      );
    }

    const imageUrl = this.props.imageUrl || chapter?.pdfUrl;

    if (imageUrl === chapter.pdfUrl && reference) {
      reference.pdfUrl = null;
    }

    if (imageUrl) {
      const imageLink = imageUrl.includes('http') ? imageUrl : null;
      const fileName = imageUrl.toLowerCase().split('/');
      return (
        <div className="SubtopicBox Pointer">
          {this.props.viewPdfPermission &&
            (this.props.isPrivatePDF ? (
              <a
                onClick={this.getPrivateUrl}
                className={className}
                target="_blank"
              >
                {fileName[fileName.length - 1]}
              </a>
            ) : (
              <a
                href={imageLink}
                className={className}
                target="_blank"
                rel="noreferrer"
              >
                {fileName[fileName.length - 1]}
              </a>
            ))}
          {(this.props.addPdfPermission || this.props.editPermission) && (
            <i
              className="fa fa-times fa-lg mt-1 ml-3"
              data-test="delete-question-image-button"
              onClick={() => this.onClickDeletePDF(chapter, true, reference)}
            />
          )}
        </div>
      );
    }

    return (
      <div className="pdf-upload cellContainer furtherReadingCell">
        {(this.props.addPdfPermission || this.props.editPermission) && (
          <label htmlFor={`file-input-${chapter.id}`}>
            <i
              className="fa fa-cloud-upload icons font-2xl d-block mt-2 pointer "
              data-test="upload-question-image-button"
            />
          </label>
        )}
        <input
          id={`file-input-${chapter.id}`}
          data-test="question-file-upload-button"
          type="file"
          accept={accept}
          disabled={this.props.isWaiting}
          onChange={(e) => {
            if (!this.props.isWaiting) {
              const pdfFile = e.target.files[0];

              // Check file size limits if provided
              const { minFileSize, maxFileSize } = this.props;

              if (minFileSize && pdfFile.size < minFileSize) {
                this.handleFileSizeError({
                  fileName: pdfFile.name,
                  fileSize: pdfFile.size,
                  minSize: minFileSize,
                  maxSize: maxFileSize,
                  type: 'min',
                });
                e.target.value = '';
                return;
              }

              if (maxFileSize && pdfFile.size > maxFileSize) {
                this.handleFileSizeError({
                  fileName: pdfFile.name,
                  fileSize: pdfFile.size,
                  minSize: minFileSize,
                  maxSize: maxFileSize,
                  type: 'max',
                });
                e.target.value = '';
                return;
              }
              updateQuestionPdfProcessing(chapter.id);
              const reference = chapter.reference?.id || chapter.reference;
              const myNewFile = new File(
                [pdfFile],
                pdfFile.name.replace('.PDF', '.pdf'),
                { type: pdfFile.type },
              );
              const updatedChapter = {
                pdf: myNewFile,
                reference,
              };

              try {
                updateChapter(updatedChapter, chapter.id, true, reference);
              } catch (err) {}
            }
          }}
        />
      </div>
    );
  }

  render() {
    const {
      chapter,
      updateQuestionPdfProcessing,
      questionPdfProcessing,
      updateChapter,
      accept,
      className,
      reference,
    } = this.props;

    return (
      <>
        {/* it's called renderPDF but we use also to images. */}
        {this.renderPdf(
          chapter,
          updateQuestionPdfProcessing,
          questionPdfProcessing,
          updateChapter,
          accept,
          className,
          reference,
        )}
        {/* File Size Error Modal */}
        {this.state.showFileSizeModal && this.state.fileSizeError && (
          <div
            className="modal fade show"
            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <FileSizeErrorModal
                  onClose={this.closeFileSizeModal}
                  fileName={this.state.fileSizeError.fileName}
                  fileSize={this.state.fileSizeError.fileSize}
                  minSize={this.state.fileSizeError.minSize}
                  maxSize={this.state.fileSizeError.maxSize}
                />
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}
